import React from 'react'
import Header from '../components/Header'
import "./Styles.css"
import Footer from '../Sections/Footer'

const Conduct = () => {
    return (
        <div className='pages-wrapper-main'>
            <Header />
            <div className='heading2'>Code of Conduct</div>
            <div className='pages'>
                <h5>  1. Purpose:</h5>

                Definition:

                The Code of Conduct serves as a guideline for fostering a positive and respectful community within Intern Crafters. It outlines the values and principles that we uphold and expect all members of our community to adhere to.

                Values and Principles:

                At Intern Crafters, we are committed to promoting an environment of respect, inclusivity, and professionalism. We believe in treating everyone with dignity and fairness, regardless of their background, identity, or beliefs.
                <br></br>
                <br></br>

                <h5>2. Expected Behavior:</h5>

                For Users:

                Users are expected to engage in discussions and interactions with respect and courtesy towards others.

                Users should refrain from engaging in any form of discrimination, harassment, or bullying.

                Users are encouraged to contribute positively to discussions and support each other's growth and learning.


                For Company Representatives:

                Company representatives are expected to lead by example and uphold the values of the company in all interactions.

                Company representatives should listen to user feedback and concerns with empathy and openness.

                Company representatives should act in the best interests of the community and prioritize the well-being of its members.

                <br></br>
                <br></br>

                <h5> 3. Unacceptable Behavior:</h5>

                Examples of Unacceptable Behavior:

                Harassment, discrimination, or intimidation based on race, gender, sexual orientation, religion, disability, or any other characteristic.

                Posting offensive or derogatory comments, images, or content.

                Engaging in personal attacks, threats, or bullying behavior towards others.

                Violating the privacy or confidentiality of other community members.

                <br></br>
                <br></br>

                <h5>4. Consequences:</h5>

                Potential Consequences for Violations:

                Violations of the Code of Conduct may result in warnings, temporary suspensions, or permanent bans from participating in the community.

                The severity of the consequences will depend on the nature and severity of the violation, as determined by Intern Crafters.

                All enforcement actions will be taken with fairness and consistency, following a thorough investigation of the incident.

                <br></br>
                <br></br>

                <h5>5. Reporting Procedure:</h5>



                How to Report Violations:

                Users can report violations of the Code of Conduct by contacting our team via interncrafters@gmail.com.

                Reports will be treated with confidentiality and taken seriously by Intern Crafters.

                Users who report violations will be protected from retaliation or harassment.

                <br></br>
                <br></br>
                <h5>6. Review and Revision:</h5>

                Periodic Review Process:

                The Code of Conduct will be reviewed periodically to ensure that it remains relevant and effective in maintaining a positive community environment.
            </div>
            <Footer />
        </div>
    )
}

export default Conduct
